import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["disableRadio", "excludeSelect", "disableText", "excludeText"];

  declare disableRadioTargets: HTMLInputElement[];
  declare excludeSelectTarget: HTMLSelectElement;
  declare disableTextTargets: HTMLElement[];
  declare excludeTextTargets: HTMLElement[];

  connect() {
    this.update();
  }

  update() {
    const disabling = this.disableRadioTargets.find((radio) => radio.checked)?.value === "true";
    const excluding = this.excludeSelectTarget.value === "true";

    this.disableTextTargets.forEach((span) => span.classList.toggle("is-hidden", !disabling));
    this.excludeTextTargets.forEach((span) => span.classList.toggle("is-hidden", !excluding));
  }
}
